// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__ppse5","selects":"Documents_selects__21BAL"};